import generateId from '@/utils/generateId'
import { Logs } from '.'
import { v2Host } from '@/config/host'

export const veproLogs = new Logs({
  baseUrl: 'https://playable-stats.mintegral.net/pt',
  env: process.env.NODE_ENV === 'production' ? 'p' : 't',
  sid: generateId(),
  v: process.env.TAG,
  tp: 've',
  autoPv: false,
})

export const veproTrackEvent = new Logs({
  baseUrl: `${v2Host}/track/event`,
  env: process.env.NODE_ENV === 'production' ? 'p' : 't',
  sid: generateId(),
  v: process.env.TAG,
  tp: 've',
  autoPv: false,
  autoFp: false,
})

export const VE_REPLACE_TP = 've_rp'
